import type { MouseEvent } from 'react'

const MAIN_CONTENT_ID = 'main-content'
const MAIN_CONTENT_HASH = `#${MAIN_CONTENT_ID}`

/** Move keyboard focus to `<main id="main-content">` and sync the URL hash. */
export function focusMainContent(event: MouseEvent<HTMLAnchorElement>) {
  event.preventDefault()

  const main = document.getElementById(MAIN_CONTENT_ID)
  if (!main) return

  main.focus()
  main.scrollIntoView({ behavior: 'smooth' })

  if (window.location.hash !== MAIN_CONTENT_HASH) {
    history.replaceState(null, '', `${window.location.pathname}${window.location.search}${MAIN_CONTENT_HASH}`)
  }
}
